module.exports = __webpack_public_path__ + "img/googlemap.c2ed6887.png";